(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  let close = document.querySelector('#close_btn');
  let topBar = document.querySelector('#top_bar');

  if (topBar) {
    close.addEventListener('click', (e) => {
      topBar.classList.add('hide-bar');
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  let menuItems = document.querySelectorAll('#header_mobile > li');

  if (menuItems) {
    menuItems.forEach((item) => {
      if (item.querySelector('.menu_dropdown')) {
        item.addEventListener('click', (e) => {
          if (
            e.target == item.querySelector('.menu_dropdown') ||
            e.target == item.querySelector('.menu_dropdown svg')
          ) {
            item.classList.toggle('dropdown-active');
          }
        });
      }
    });
    // Mobile Submenu Dropdown

    let submenuDropdown = document.querySelectorAll('.simple-dropdown-submenu').forEach((item) => {
      item.addEventListener('click', (e) => {
        if (item.querySelector('.simple-dropdown-menu')) {
          item.querySelector('.simple-dropdown-menu').classList.toggle('dropdown-active');
        }
      });
    });
  }

  document.addEventListener('keydown', (e) => {
    let searchBar = document.querySelector('.search-wrapper');
    // Escape

    if (e.key === 'Escape') {
      if (searchBar) {
        searchBar.setAttribute('class', 'search-wrapper fade-in-up');
      }
    }

    // Search Enter

    if (e.key === 'Enter') {
      let searchButton = document.querySelector('.header-right .search-user');

      if (searchButton && e.target == searchButton) {
        searchBar.setAttribute('class', 'search-wrapper fade-in-up show-search');
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-address"]) return;
  try {
    
  let countryOption = document.querySelector('.country_edit_main');
  let editForm = document.querySelector('#edit_address_main');
  let countryError = document.querySelector('#country_error');
  let updateAddress = document.querySelector('#edit_address_update');
  let formValid = true;

  window.addEventListener('load', (e) => {
    if (countryOption.value == '---') {
      formValid = false;
    } else {
      formValid = true;
    }
  });

  countryOption.addEventListener('change', (e) => {
    if (countryOption.value == '---') {
      formValid = false;
    } else {
      formValid = true;
    }
  });

  updateAddress.addEventListener('click', (e) => {
    if (formValid == false) {
      e.preventDefault();
      countryError.innerHTML = 'Please select an option';
    } else {
      editForm.submit();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modal-main"]) return;
  try {
    
  let closeBtn = document.querySelector('#modal_close');
  let modalMain = document.querySelector('#modal_main');

  setTimeout(() => {
    modalMain.classList.add('modal-active');
  }, 7000);

  closeBtn.addEventListener('click', () => {
    modalMain.classList.add('hide-modal');
    sessionStorage.setItem('modalStatus', 'hidden');
    console.log('Working!');
  });

  if (sessionStorage.getItem('modalStatus') == 'hidden') {
    modalMain.classList.add('hide-modal');
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !window.DesignMode) return;
  try {
    
  function newsletterErrorHandle() {
    let form = document.querySelector('#newsletter_form_main > form');
    let formEmail = document.querySelector('#newsletter_email_input');

    form.addEventListener('click', (e) => {
      if (formEmail.value == ' ') {
        e.preventDefault();
      }
    });
  }

  newsletterErrorHandle();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });

  observer.observe(productRecommendationsSection);

  // Swiper

  window.addEventListener('load', (e) => {
    const productSingleSwiper = new Swiper('#recommendations-swiper', {
      // Default parameters
      slidesPerView: 3,
      pagination: { el: '#recommendations-swiper .swiper-pagination', clickable: true },
      navigation: {
        nextEl: '#recommendations-swiper .swiper-button-next',
        prevEl: '#recommendations-swiper .swiper-button-prev',
      },
      loop: false,
      spaceBetween: 30,
      // Responsive breakpoints
      breakpoints: {
        // when window width is >= 320px
        0: {
          slidesPerView: 1,
        },
        // when window width is >= 480px
        540: {
          slidesPerView: 2,
        },
        // when window width is >= 640px
        1024: {
          slidesPerView: 3,
        },
      },
    });

    productSingleSwiper.init();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-collection2"]) return;
  try {
    
  Shopify.queryParams = {};
  // Preserve existing query parameters
  if (location.search.length) {
    var params = location.search.substr(1).split('&');
    for (var i = 0; i < params.length; i++) {
      var keyValue = params[i].split('=');
      if (keyValue.length) {
        Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]);
      }
    }
  }
  // Update sort_by query parameter on select change
  document.querySelector('#sort-by').addEventListener('change', function (e) {
    var value = e.target.value;
    Shopify.queryParams.sort_by = value;
    location.search = new URLSearchParams(Shopify.queryParams).toString();
  });

  function filterByCollection() {
    let filterOptions = document.querySelectorAll('#filter_by_collection input[value]');

    for (let j = 0; j < filterOptions.length; j++) {
      let filterUrl = filterOptions[j].getAttribute('value');
      //  let newUrl = window.location.hostname + filterUrl ;

      filterOptions[j].addEventListener('click', () => {
        window.open(filterUrl, '_self');
      });
    }
  }

  filterByCollection();
  // setting next icon
  const next = document.querySelector('.next');
  if (next != null) {
    let nextContent = next.children[0];
    nextContent.innerHTML = `
    <img src="https://cdn.shopify.com/s/files/1/0441/3027/1389/files/navigation_next.svg?v=1673520127" width="" height="" loading="lazy" alt="shopify">
    `;
  }

  // setting previous icon
  const prev = document.querySelector('.prev');
  if (prev != null) {
    let prevContent = prev.children[0];
    prevContent.innerHTML = `
    <img src="https://cdn.shopify.com/s/files/1/0441/3027/1389/files/navigation.svg?v=1673519308" width="" height="" loading="lazy" alt="shopify">
    `;
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      let sidebar = document.querySelector('#collection_sidebar');
      if (sidebar) {
        sidebar.setAttribute('class', '');
      }
    }
  });

  } catch(e) { console.error(e); }
})();

})();
